import React from 'react';
import { DataList, CustomModal } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';
import useDashboardActions from 'pages/dashboard/useDashboardActions';
import useService from '../../utils/useService';
import { columnConfigs, PAGE_DETAILS } from './listConfig';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';

const ZkChangeHistory: React.FC<{}> = () => {
	const { getZkChangeHistory } = useService();
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const actions = getActionList();
	return (
		<div>
			<CustomModal />
			<DataList
				fetchData={getZkChangeHistory}
				columnConfigs={columnConfigs}
				getActionHandler={getActionHandler}
				actions={actions}
				defaults={PAGE_DETAILS}
				entity={LIST_ENTITY_NAMES.zkRevertDashboard}
				rowHeight={50}
				initialSortDirection='DESC'
				initialSortIndex={1}
			/>
		</div>
	);
};

export default ZkChangeHistory;
